export enum NodeType {
    END_NODE = 'END_NODE',
    LEGACY_NAVIGATION = 'LEGACY_NAVIGATION',
    NAVIGATION = 'NAVIGATION',
}
